export default class ContainerDragger {
	constructor(containerElement, handlerSelector, excludedSelectors = [], minDragPositionChangePx = 10) {
		this.dragData = {
			x: null,
			left: null,
			target: null,
		};
		this.minDragPositionChangePx = minDragPositionChangePx;
		this.excludedSelectors = excludedSelectors.join(',');
		this.handlerSelector = handlerSelector;

		this.containerEl = containerElement;

		this.$containerEl = $(containerElement);
		this.isContainerScrollable = this.isContainerScrollableFce();

		this.$dragAndDropHandler = this.$containerEl.find(handlerSelector).not(this.excludedSelectors);

		this.setDraggingInProcess(false);

		this.$dragAndDropHandler.on('mousedown', this.onMouseDown.bind(this));
		document.addEventListener('mousemove', this.onMouseMove.bind(this));
		document.addEventListener('mouseup', this.onMouseUp.bind(this));
		$(window).on('resize', this.onContainerResize.bind(this));

	}

	setDraggingInProcess(val) {

		this.isDragging = this.isContainerScrollable ? val : false;
		this.isDraggingConfirmed = false;
		this.adjustCursor();
	}

	refresh() {
		this.$dragAndDropHandler.off('mousedown', this.onMouseDown);
		this.$dragAndDropHandler = this.$containerEl.find(this.handlerSelector).not(this.excludedSelectors);
		this.setDraggingInProcess(false);
		this.$dragAndDropHandler.on('mousedown', this.onMouseDown.bind(this));
	}



	adjustCursor() {
		if (this.dragData?.target) {
			if (this.isContainerScrollable && this.isDragging) {
				this.dragData.target.style.cursor = 'grabbing';
			}
			else {
				this.dragData.target.style.cursor = '';
			}
		}

	}

	onContainerResize() {
		this.setDraggingInProcess(false);
	}

	isContainerScrollableFce() {
		const containerWidth = this.$containerEl.width();
		const paddingLeft = parseInt(window.getComputedStyle(this.containerEl)['padding-left'], 10);
		const paddingRight = parseInt(window.getComputedStyle(this.containerEl)['padding-right'], 10);
		let paddingX = 0;
		if (!isNaN(paddingLeft)) paddingX += paddingLeft;
		if (!isNaN(paddingRight)) paddingX += paddingRight;
		return (this.containerEl.scrollWidth - paddingX - 1) > containerWidth;
	}

	isExcludedSelector(targetElement) {
		return $(targetElement).is(this.excludedSelectors) || $(targetElement).closest(this.excludedSelectors).length > 0;
	}

	onMouseDown(e) {

		if (!this.isExcludedSelector(e.target)) {
			this.dragData = {
				left: this.containerEl.scrollLeft,
				x: e.clientX,
				target: e.target,
			};
			this.setDraggingInProcess(true);
			if (this.onBlockClickTimeout) clearTimeout();
			this.unblockClick();
		}
		else return true;

	}


	onMouseUp(e) {
		if (this.isDragging) {
			this.setDraggingInProcess(false);
			const dx = Math.abs(e.clientX - this.dragData.x);
			if (dx > this.minDragPositionChangePx) {
				this.blockClick();
				if (this.onBlockClickTimeout) clearTimeout();
				this.onBlockClickTimeout = setTimeout(() => {
					this.unblockClick();
				}, 200);
			}
			else {
				this.unblockClick();
			}
		}
		else {
			this.unblockClick();
		}
	}

	blockClick() {
		if (this.dragData) {
			$(this.dragData.target).on('mousedown', this.stopClickPropagation);
			$(this.dragData.target).on('click', this.stopClickPropagation);

		}
	}


	unblockClick() {
		if (this.dragData) {

			$(this.dragData?.target).off('mousedown', this.stopClickPropagation);
			$(this.dragData?.target).off('click', this.stopClickPropagation);
		}
	}

	onMouseMove(e) {
		if (this.isDragging) {
			if (this.isExcludedSelector(e.target)) return;
			e.preventDefault();
			e.stopPropagation();
			// How far the mouse has been moved
			const dx = e.clientX - this.dragData.x;
			// Scroll the element
			this.containerEl.scrollLeft = this.dragData.left - dx;
			if (dx > this.minDragPositionChangePx) {

				this.blockClick();
			}
		}
	}


	stopClickPropagation = (event) => {
		if (event) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
		return false;
	};


}